module.exports = __webpack_public_path__ + "img/expand-more.46c14449.svg";